module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    class: ['table', _vm.striped ? 'table-striped' : '', _vm.hover ? 'table-hover' : '']
  }, [_c('thead', [_c('tr', _vm._l((_vm.fields), function(field, key) {
    return _c('th', {
      class: [field.sortable ? 'sorting' : null, _vm.sortBy === key ? 'sorting_' + (_vm.sortDesc ? 'desc' : 'asc') : '', field.class ? field.class : null],
      domProps: {
        "innerHTML": _vm._s(field.label)
      },
      on: {
        "click": function($event) {
          _vm.headClick(field, key)
        }
      }
    })
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm._items), function(item, index) {
    return _c('tr', {
      key: _vm.items_key,
      class: [item.state ? 'table-' + item.state : null],
      on: {
        "click": function($event) {
          _vm.rowClicked(item, index)
        }
      }
    }, _vm._l((_vm.fields), function(field, key) {
      return _c('td', {
        class: [field.class ? field.class : null]
      }, [_vm._t(key, [_vm._v(_vm._s(item[key]))], {
        value: item[key],
        item: item,
        index: index
      })], 2)
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea3a5202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/table.vue
// module id = 263
// module chunks = 0